import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Confetti from 'react-confetti';
import thumbsUpEncouragement from '../../images/thumbs-up-encouragement.png';
import './CongratsModal.css';

interface CongratsModalProps {
  show: boolean;
  onClose: () => void;
  headerText?: string;
  bodyText?: string;
  buttonText?: string;
  eyebrowText?: string;
}

const CongratsModal: React.FC<CongratsModalProps> = ({
  show,
  onClose,
  headerText,
  bodyText,
  buttonText,
  eyebrowText = 'Milestone unlocked',
}) => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="lg"
      className="congrats-modal"
      backdrop="static"
    >
      {show && (
        <Confetti
          className="congrats-modal__confetti"
          width={windowSize.width}
          height={windowSize.height}
          numberOfPieces={180}
          recycle={false}
        />
      )}
      <Modal.Body>
        <div className="congrats-modal__shell">
          <div className="congrats-modal__icon-wrap">
            <img src={thumbsUpEncouragement} alt="" className="congrats-modal__icon" />
          </div>
          <span className="congrats-modal__eyebrow">{eyebrowText}</span>
          <h1 className="congrats-modal__title">
            {headerText ?? 'Congrats on completing your SkipScreen profile!'}
          </h1>
          <p className="congrats-modal__body">
            {bodyText ??
              'You can now share it in job applications or directly with recruiters — one step closer to landing your dream job!'}
          </p>
          <div className="congrats-modal__actions">
            <Button
              type="button"
              variant="success"
              size="lg"
              onClick={onClose}
              className="congrats-modal__cta"
            >
              {buttonText ?? 'Continue'}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CongratsModal;
